export const translation = {
  header: {
    items: [
      {
        name: 'Главная',
        href: '/',
      },
      {
        name: 'Система',
        href: '#system',
      },
      {
        name: 'Модуль',
        href: '#module',
      },
      {
        name: 'Монтаж',
        href: '#montage',
      },
      {
        name: 'EasyLan',
        href: 'https://www.easylan.de/',
        newTab: true,
      },
    ],
    language: 'Язык',
  },

  easylan: {
    fixLink: 'fixLink<sup>®</sup>',
    hero: {
      title: {
        text1: 'Простота',
        text2: 'в соединении',
      },
      subtitle: 'Твоя связь с будущим',
      cta: 'подробнее',
    },
    handling: {
      title: 'ИНТУИТИВНОЕ ОБРАЩЕНИЕ ВСТРЕЧАЕТ ПЕРЕДОВЫЕ ТЕХНОЛОГИИ',
      vorreiterPrefix: 'Комбинация точности и функционального дизайна делает ',
      vorreiterSuffix: ' лидирующим выбором в технологии сетевых соединений.',
      experte: ' предлагает эффективные 360° решения, которые оптимально сочетают дизайн и производительность, чтобы минимизировать сложность.',
      pionier: ' является пионером в преобразовании рабочих пространств, сочетая экспертизу с интуитивно понятным обращением.',
    },
    download: {
      prefix: 'Обзор ',
      suffix: ' - загрузить систему',
      cta: 'Скачать',
      href: 'https://fixlink.eu/PUBLIC_STORAGE/FixLink_System_Uebersicht_2024_DE_v2.pdf',
    },
    system: {
      titleLabel: 'Обзор продукта',
      title: 'FIXLINK<sup>®</sup> - СИСТЕМА',
    },
    module: {
      overview: 'Скачать обзор',
      accordion: {
        ghmtCertificates: {
          title: 'GHMT - Сертификаты',
          text: 'Мы доверяем GHMT и их Premium Verification Program для независимого контроля качества наших сетевых продуктов. Это позволяет нам гарантировать самые высокие стандарты продукции для наших клиентов, основываясь на 20-летнем опыте.',
        },
        datasheets: {
          title: 'Технические паспорта',
          text: 'Здесь вы найдете все необходимые технические паспорта. Скачайте их и имейте всю информацию под рукой.',
        },
        compatibilitySheets: {
          title: 'Списки совместимости',
          text: '',
        },
        excelTemplates: {
          title: 'Окно для надписей как шаблон Excel',
          text: '',
        },
      },
    },
    video: {
      title: 'ИНСТРУКЦИЯ ПО МОНТАЖУ',
      text: 'Смотрите видео или просто скачайте PDF здесь',
      manual: {
        title: 'ИНСТРУКЦИИ ПО МОНТАЖУ:',
      },
    },
    separator: {
      title: 'Больше, чем просто соединение',
      title2: 'Откройте для себя космос EasyLan',
      text: 'Откройте разнообразие инновационных сетевых решений на EasyLan.de: Индивидуально настроено для вас. Измените вашу сеть: наши системы кабельной разводки и решения по управлению кабелями.',
      cta: 'подробнее',
    },
    combination: {
      bau: {
        prefix: 'Испытайте максимальную адаптацию и качество с ',
        text: ' держателями компонентов EasyLan ',
        suffix: 'прямо из Европы.',
      },
      intelligent: {
        prefix: 'Ваша сеть',
        text: ' на заказ ',
        suffix: 'с настраиваемой коробкой для сращивания EasyLan',
      },
      fixlink: {
        prefix: 'С нашими ',
        suffix: ' продуктами вы можете улучшить свои офисные здания на долгий срок.',
      },
      hds: {
        prefix: 'Система',
        text: ' EasyLan<sup>®</sup> H.D.S. ',
        suffix: 'объединяет легкость установки и обслуживания как никакая другая система стволовой кабельной разводки на рынке.',
      },
    },
    recommended: {
      titleLabel: 'Рекомендуется',
      title: 'fixLink<sup>®</sup> - СИСТЕМА',
      text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
      items: [
        { imgName: 'a', name: 'FIXLINK A', text: 'Lorem ipsum dolor met' },
        { imgName: 'b', name: 'FIXLINK B', text: 'Lorem ipsum dolor met' },
        { imgName: 'c', name: 'FIXLINK C', text: 'Lorem ipsum dolor met' },
        { imgName: 'd', name: 'FIXLINK D', text: 'Lorem ipsum dolor met' },
        { imgName: 'e', name: 'FIXLINK E', text: 'Lorem ipsum dolor met' },
      ],
    },
    guarantee: [
      {
        title: 'Гарантия продукта',
        text: [
          'Гарантия на продукт включает все компоненты ',
          '- оптоволоконной или медной кабельной системы, которые установлены и проверены квалифицированным монтажником в соответствии с требованиями ',
          ' и действующими нормами установки EN50174.',
        ],
      },
      {
        title: 'Гарантия производительности',
        text: [
          'Гарантия производительности дополнительно гарантирует системные характеристики, такие как скорость передачи данных (10MBit, 100MBit, 1GBit и 10GBit) для различных приложений (Ethernet, Fiber Channel, ATM и др.).',
        ],
      },
      {
        title: 'Гарантия на приложения',
        text: [
          'Гарантия на приложения гарантирует все специфицированные приложения (Ethernet, Fiber Channel, ATM и др.), которые базируются на соответствующих стандартам кабелирования ISO/IEC 11801, EN50173 и EIA/TIA 568B, действующих на момент установки.',
        ],
      },
    ],
    end: {
      title: 'СВЯЗИ НИКОГДА НЕ БЫЛИ ТАК ПРОСТЫ.',
      text: 'Интуитивное управление встречает передовые технологии; откройте для себя бесшовное соединение будущего: fixLink<sup>®</sup>',
    },
    categoryData: {
      modules: 'Модули подключения',
      csm_FixLink_Pro03_b20813b518: {
        name: 'Pro RJ45 Keystone-модуль Cat. 6A ISO/IEC, экранированный',
        text: 'С модулем fixLink<sup>®</sup> Pro RJ45 Keystone пользователь получает модуль RJ45 высочайшего качества. Модуль fixLink<sup>®</sup> Pro RJ45 Keystone можно собрать с помощью бокорезов за менее чем минуту. Благодаря свободно доступной контактной зоне обеспечивается идеальное качество сборки и, следовательно, гарантируется надежная производительность передачи. Специальная контактная геометрия в сочетании с 30 μ" позолотой обеспечивает соответствие стандарту 4PPoE по IEEE 802.3bt при любых условиях. Корпус выполнен из никелированного цинкового литья под давлением, что соответствует самым высоким экологическим и механическим требованиям. В сочетании с модульным адаптером возможна комбинация с любыми программами переключателей. Модули поставляются в экологически чистой картонной упаковке.',
        ghmtCertificates: [
          {
            name: 'Сертификат PVP Cat.6A',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Pro+RJ45+Keystone-Modul/z5951i-20.pdf',
          },
          {
            name: 'Сертификат постоянной связи',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Pro+RJ45+Keystone-Modul/z8144a-23.pdf',
          },
        ],
      },
      csm_fixLink_Extender_a0613ee77a: {
        name: 'Удлинитель Cat. 6A ISO/IEC, экранированный',
        text: 'С удлинителем fixLink<sup>®</sup> можно легко удлинить кабели. Кроме того, можно повторно активировать заброшенные линии и удлинить их до следующей необходимой точки подключения. Ограниченное пространство в кабельном канале используется оптимально. Удлинитель просто прикручивается к концу установленного кабеля в канал или к стене. После установки удлиненный таким образом кабель можно использовать для передачи данных на скорости до 10 Гбит/с и поддерживает PoE+ (Power over Ethernet).',
      },
      csm_fixLinkRJ45Plug_Katalog_c858f0a6ed: {
        name: 'RJ45 Plug Cat. 6A ISO/IEC, экранированный',
        text: 'С модулем fixLink<sup>®</sup> RJ45 пользователь получает модуль RJ45 высочайшего качества и гибкости, пригодный для полевых условий. Специальная контактная геометрия в сочетании с 50 μ" позолотой обеспечивает соответствие стандарту 4PPoE по IEEE 80.3bt при любых условиях. Корпус выполнен из никелированного цинкового литья под давлением, что соответствует самым высоким экологическим и механическим требованиям. Различные сертификаты (актуальный список: www.easylan.de) от независимых лабораторий подтверждают высокое качество системы fixLink<sup>®</sup>.',
      },
      csm_FixlinkUTP_e5de94d502: {
        name: 'RJ45 Keystone-модуль Cat. 6A EIA/TIA, неэкранированный',
        text: 'С модулем fixLink<sup>®</sup> RJ45 Keystone (совместимым с PoE+) пользователь получает модуль RJ45 высочайшего качества. Модуль fixLink<sup>®</sup> RJ45 Keystone можно собрать с помощью бокорезов за менее чем минуту. Благодаря свободно доступной контактной зоне обеспечивается идеальное качество сборки и, следовательно, гарантируется надежная производительность передачи. Корпус выполнен из поликарбоната, что соответствует самым высоким экологическим и механическим требованиям. В сочетании с модульным адаптером возможна комбинация с любыми программами переключателей. Различные сертификаты от независимых лабораторий подтверждают высокое качество модулей fixLink<sup>®</sup> SL Keystone. Модули поставляются в экологически чистой картонной упаковке.',
      },
      fixLink_SL_02: {
        name: 'SL RJ45 Keystone-модуль Cat. 6A ISO/IEC, экранированный',
        text: 'С модулем fixLink<sup>®</sup> SL RJ45 пользователь получает модуль RJ45 высочайшего качества. Модуль fixLink<sup>®</sup> SL RJ45 можно собрать с помощью бокорезов за менее чем минуту. Благодаря свободно доступной контактной зоне обеспечивается идеальное качество сборки и, следовательно, гарантируется надежная производительность передачи. Для 360° экранирования достаточно защелкнуть интегрированный клин, что устраняет необходимость в установке кабельной стяжки. Специальная контактная геометрия в сочетании с 50 μ" позолотой обеспечивает соответствие стандарту 4PPoE по IEEE 802.3bt при любых условиях. Корпус выполнен из никелированного цинкового литья под давлением, что соответствует самым высоким экологическим и механическим требованиям. В сочетании с модульным адаптером возможна комбинация с любыми программами переключателей. Различные сертификаты от независимых лабораторий подтверждают высокое качество модулей fixLink<sup>®</sup> SL Keystone. Модули поставляются в экологически чистой картонной упаковке.',
        ghmtCertificates: [
          {
            name: 'Сертификат PVP Cat.6A',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul/z5951i-20.pdf',
          },
          {
            name: 'Отчет об испытаниях 4PoE по DIN EN ISO/IEC 17025',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul/P4712a-17-D.pdf',
          },
          {
            name: 'Сертификат постоянной связи GHMT',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul/z8144a-23.pdf',
          },
        ],
      },
      fixLinkSLGewinkelt: {
        name: 'SL RJ45 Keystone-модуль с углом Cat. 6A ISO/IEC, экранированный',
        text: 'С модулем fixLink<sup>®</sup> SL RJ45 пользователь получает модуль RJ45 высочайшего качества, разработанный специально для применения в условиях ограниченного пространства. Благодаря углу в 75° модуль особенно подходит для использования в розетках и полых кабельных каналах. Минимальная монтажная глубина в 27 мм позволяет использовать модуль в самых разнообразных приложениях. Модуль fixLink<sup>®</sup> SL RJ45 можно собрать с помощью бокорезов за менее чем минуту. Благодаря свободно доступной контактной зоне обеспечивается идеальное качество сборки и, следовательно, гарантируется надежная производительность передачи. Специальная контактная геометрия в сочетании с 50 μ" позолотой обеспечивает соответствие стандарту PoE+ по IEEE 80.3at при любых условиях. Корпус выполнен из никелированного цинкового литья под давлением, что соответствует самым высоким экологическим и механическим требованиям. В сочетании с модульным адаптером возможна комбинация с любыми программами переключателей. Различные сертификаты от независимых лабораторий подтверждают высокое качество модулей fixLink<sup>®</sup> SL Keystone. Модули поставляются в экологически чистой картонной упаковке.',
        ghmtCertificates: [
          {
            name: 'Сертификат GHMT PVP Cat.6A',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul+gewinkelt/z5951i-20.pdf',
          },
          {
            name: 'Сертификат постоянной связи GHMT',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul+gewinkelt/z8144a-23.pdf',
          },
        ],
      },
      werkzeugeUndZubehoer: {
        name: 'Инструменты и аксессуары',
        text: [
          'Инструмент для снятия оболочки для удаления внешней оболочки и металлических фольг кабеля данных. Синий цвет.',
          'Медная лента для фиксации экрана. Предварительно нарезана на 35 x 9 мм. Единица упаковки: 20 штук/пакет 1500 штук/рулон',
          'Цветные защитные крышки от пыли для модулей preLink® SL и fixLink® SL Keystone.',
          'Единица упаковки 50 штук/полиэтиленовый пакет',
        ],
        ghmtCertificates: [
          {
            name: 'Сертификат GHMT PVP Кат.6A',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul+gewinkelt/z5951i-20.pdf',
          },
          {
            name: 'Сертификат GHMT Permanent Link',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/SL+RJ45+Keystone-Modul+gewinkelt/z8144a-23.pdf',
          },
        ],
      },
      verlegekabel: 'Монтажный кабель',
      goldCsm_Datenkabel_SFTP_orange_074bad6e0f: {
        name: 'Кабель данных EasyLan® Gold S/FTP AWG22/1 1500 MHz Кат. 7A',
        text: [
          'Кабель данных для передачи аналоговых и цифровых сигналов при кабелировании в первичной, вторичной и третичной областях. Подходит для применения до класса FA.',
        ],
        ghmtCertificates: [
          {
            name: 'Сертификат GHMT PVP',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Gold/z7566f-22.pdf',
          },
          {
            name: 'Сертификат GHMT Permanent Link',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Gold/z8144a-23.pdf',
          },
        ],
        datasheets: [
          {
            name: 'Технический паспорт',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Gold/ZN-DK210304_J_EasyLan_Datasheet_Data_Cable_S-FTP_Gold_AWG22_Cat7A_1500MHz.pdf',
          },
        ],
      },
      silberCsm_Datenkabel_SFTP_orange_074bad6e0f: {
        name: 'Кабель данных EasyLan® Silber S/FTP AWG23/1 1200 MHz Кат. 7A',
        text: [
          'Кабель данных для передачи аналоговых и цифровых сигналов при кабелировании в первичной, вторичной и третичной областях. Подходит для применения до класса FA.',
        ],
        ghmtCertificates: [
          {
            name: 'Сертификат GHMT PVP',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Silber/z7565e-22.pdf',
          },
        ],
        datasheets: [
          {
            name: 'Технический паспорт',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Silber/ZN-DK210305_J_EasyLan_Datasheet_Data_Cable_S-FTP_Silver_AWG23_Cat7A_1200MHz.pdf',
          },
        ],
      },
      bronzeCsm_Datenkabel_SFTP_orange_074bad6e0f: {
        name: 'Кабель данных EasyLan® Bronze S/FTP AWG23/1 1000 MHz Кат. 7',
        text: 'Кабель данных для передачи аналоговых и цифровых сигналов при кабелировании в первичной, вторичной и третичной областях. Подходит для применения до класса FA.',
        datasheets: [
          {
            name: 'Технический паспорт',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Verlegekabel_Bronze/ZN-DK210306_L_EasyLan_Datasheet_Data_Cable_S-FTP_Bronze_AWG23_Cat7_1000MHz.pdf',
          },
        ],
      },
      datendosen: 'Розетки данных',
      csm_Abdeckrahmen_1fach_d4075872d1: {
        name: 'Настенные корпуса и рамки для модульных адаптеров',
        text: [
          'Настенный корпус IP20, 80x80x42 мм для установки модульных адаптеров EasyLan',
          'Промежуточная рамка для настенного корпуса для увеличения высоты на 10 мм',
          'Рамка 1-местная 80x80 мм',
          'Рамка 2-местная 80x150 мм',
        ],
        datasheets: [
          {
            name: 'Настенный корпус',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/AP-Geh%C3%A4use+und+Rahmen+f%C3%BCr+vorgenannte+Modulaufnahmen/ZN-CU161044_B_ADZ00101_EasyLan_Datasheet_Aufputzgeha%CC%88use.pdf',
          },
          {
            name: 'Расширение глубины настенного корпуса',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/AP-Geh%C3%A4use+und+Rahmen+f%C3%BCr+vorgenannte+Modulaufnahmen/ZN-CU161045_B_CKVDDR90_EasyLan_Datasheet_Tiefenerweiterung_AP-Geha%CC%88use.pdf',
          },
        ],
      },
      csm_Datendose_1PortmitRahmen_a8e4d5e731: {
        name: 'Модульный адаптер SL, угловой выход 45°, UP, BK, AP, BT 1-местный, 2-местный, 3-местный',
        text: 'Модульные адаптеры SL особенно подходят для установки в кабельные каналы (EK), подштукатурного монтажа (UP) и настенного монтажа (AP). С помощью ломания двух монтажных лапок также возможен монтаж в напольных баках (BT). Модульный адаптер SL может надежно и долговечно удерживать один-три модуля EasyLan Keystone. Он имеет большое, центрально расположенное окно для маркировки для простого обозначения. Центральная панель (50x50 мм) и рамка (80x80 мм) выполнены из устойчивого к УФ-лучам и чрезвычайно прочного пластика, что гарантирует долговечный и цветостойкий внешний вид.',
      },
      csm_Datendose_designfähig_1fach_f35757e7bc: {
        name: 'Дизайнерский модульный адаптер SL, угловой выход 45°, UP, BK, AP, BT 1-местный, 2-местный',
        text: 'Дизайнерский модульный адаптер выполнен из рамы из литого под давлением цинка. Он подходит для установки в кабельные каналы (EK), для подштукатурного монтажа (UP) или с помощью отдельной рамки также для настенного монтажа (AP). С помощью ломания двух монтажных лапок также возможен монтаж в напольных баках (BT). Дизайнерская розетка совместима с практически всеми программами переключателей на рынке. Из-за совместимости с UAE-дизайном дизайнерская розетка не имеет места для защитной крышки от пыли.',
        datasheets: [
          {
            name: '1-/2-местный Keystone, без центральной панели',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Designf%C3%A4hige+Modulaufnahme+SL/ZN-BL151005_F_CKVD1DS_EasyLan_Datasheet_designfa%CC%88hige_Modulaufnahme_1-_2-fach_ohne_ZP.pdf',
          },
          {
            name: '2-местный Keystone, с центральной панелью 50x50 мм',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Designf%C3%A4hige+Modulaufnahme+SL/ZN-BL151006_E_EasyLan_CKVD1D1_Datasheet_designfa%CC%88hige_Modulaufnahme_SL_2-fach_mit_ZP.pdf',
          },
          {
            name: '1-местный с центральной панелью',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Designf%C3%A4hige+Modulaufnahme+SL/ZN-BL161067_B_EasyLan_CKVD1D2_Datasheet_designfa%CC%88hige_Modulaufnahme_SL_mit_ZP_1-fach.pdf',
          },
        ],
      },
      csm_IP44_AP_Dose_offen_2e48717c62: {
        name: 'Модульный адаптер IP44 настенный, 1-местный, 2-местный',
        text: 'Прочный настенный корпус подходит для установки двух модулей preLink<sup>®</sup> / fixLink<sup>®</sup> Keystone с помощью адаптера. Для ввода двух кабелей диаметром 5,0 - 9,5 мм на задней стороне корпуса имеются легко прокалываемые отверстия. Модульный адаптер достигает класса защиты IP20 в подключенном состоянии и класса защиты IP44 в закрытом состоянии.',
      },
      DoseUPleer2xKS: {
        name: 'Модульный адаптер с прямым выходом, 2-местный',
        text: 'Модульный адаптер с прямым выходом Keystone выполнен из рамы из литого под давлением цинка и подходит для установки в кабельные каналы (EK), подштукатурного (UP) или с помощью отдельной рамки также для настенного монтажа (AP).',
      },
      bodentank: 'Напольный бак',
      csm_Bodentank_2er_Rahmen_fa84a9dd52: {
        name: 'Системы напольных баков OBO/Ackermann UT3, UT4',
        text: 'Носовая плита заменяет держатели устройств, обеспечивая максимальное пространство для проводки кабелей. Косой ввод и вывод кабеля обеспечивает надежное управление кабелями даже при очень низких промежуточных уровнях. Возможна комбинация с монтажными пластинами для 4 модулей preLink<sup>®</sup>/fixLink<sup>®</sup> или 1 модуля H.D.S. Монтажные пластины крепятся к носовой плите двумя винтами, неиспользуемые поля носовой плиты могут быть закрыты защитными пластинами от пыли.',
        datasheets: [
          {
            name: 'Носовая плита для UT3 без монтажной пластины',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Bodentanksysteme+UT3/ZN-CU161042_C_ABG00011_EasyLan_Datasheet_Bodentanktraegerplatte_UT3.pdf',
          },
          {
            name: 'Носовая плита для UT4 без монтажной пластины',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Bodentanksysteme+UT3/ZN-CU161041_C_ABG00012_EasyLan_Datasheet_Bodentanksystem_UT4.pdf',
          },
        ],
      },
      csm_OBO_Bodentanktraeger_Basic_6x_Kestone_84e5329394: {
        name: 'Держатель напольного бака OBO/Ackermann Basic UT3, UT4',
        text: 'Держатель напольного бака для Keystone заменяет держатель устройства, обеспечивая максимальное пространство для проводки кабелей. Косой ввод и вывод кабеля обеспечивает надежное управление кабелями даже при очень низких промежуточных уровнях. Монтажные пластины крепятся к носовой плите двумя винтами, неиспользуемые отверстия держателя напольного бака могут быть закрыты защитными пластинами от пыли. С помощью адаптера держатель напольного бака может быть также использован для держателей устройств Electraplan.',
        datasheets: [
          {
            name: 'Держатель напольного бака UT3 для до 6 модулей',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Bodentanktr%C3%A4ger+Basic+UT3/ZN-BL161056_C_ABGECO23_EasyLan_Datasheet_Bodentanktraeger_ECO_UT3_fuer_bis_zu_6_Module.pdf',
          },
          {
            name: 'Держатель напольного бака UT4 для до 9 модулей',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Bodentanktr%C3%A4ger+Basic+UT3/ZN-BL161055_C_ABGECO33_EasyLan_Datasheet_Bodentanktraeger_ECO_UT4_fuer_bis_zu_9_Module.pdf',
          },
          {
            name: 'Держатель напольного бака UT4 для до 12 модулей',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Bodentanktr%C3%A4ger+Basic+UT3/ZN-BL161057_D_ABGECO34_EasyLan_Datasheet_Bodentanktraeger_ECO_UT4_fuer_bis_zu_12_Module.pdf',
          },
        ],
      },
      csm_PUK_Bodentank_3x3KS_2752d44a76: {
        name: 'Держатель напольного бака PUK Basic UT4',
        text: 'Держатель напольного бака для Keystone заменяет держатель устройства, обеспечивая максимальное пространство для проводки кабелей. Косой ввод и вывод кабеля обеспечивает надежное управление кабелями даже при очень низких промежуточных уровнях. Монтажные пластины крепятся к носовой плите двумя винтами, неиспользуемые отверстия держателя напольного бака могут быть закрыты защитными пластинами от пыли. Держатели напольных баков совместимы с системой напольных баков PUK.',
        datasheets: [
          {
            name: 'Держатель напольного бака UT4 для до 9 модулей',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/PUK+Bodentanktr%C3%A4ger+Basic+UT4/ZN-BL181395_B_ABGPUK33_EasyLan_Datasheet_Bodentanktraeger_PUK_3x3_Keystones.pdf',
          },
          {
            name: 'Держатель напольного бака UT4 для до 12 модулей',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/PUK+Bodentanktr%C3%A4ger+Basic+UT4/ZN-BL181396_B_ABGPUK34_EasyLan_Datasheet_Bodentanktraeger_PUK_3x4_Keystones.pdf',
          },
        ],
      },
      OSO_Einsatz_3xKS: {
        name: 'Вставки OBO/Ackermann для систем напольных баков UT3, UT4, аксессуары',
        text: 'Вставки для модулей не имеют порошкового покрытия и оцинкованы для заземления. Монтажные пластины крепятся к носовой плите двумя винтами, неиспользуемые поля носовой плиты могут быть закрыты защитными пластинами от пыли.',
        datasheets: [
          {
            name: 'Монтажная плита для 4 модулей RJ45',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Eins%C3%A4tze+f%C3%BCr+Bodentanksysteme+UT3/ZN-CU161043_B_EasyLan_Datasheet_Bodentanktraegereinsatz_4xKS_ABG00014.pdf',
          },
          {
            name: 'Монтажная плита для 3 модулей RJ45',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/OBO-Ackermann+Eins%C3%A4tze+f%C3%BCr+Bodentanksysteme+UT3/ZN-CU200571_B_EasyLan_Datasheet_Bodentanktraegereinsatz_3xKS_ABG00016.pdf',
          },
        ],
      },
      hutschienenadapter: 'Адаптер для монтажной рейки',
      csm_Hutschienenmodul_Kompakt_01_66214719b0: {
        name: 'Компактный модульный корпус для монтажной рейки для 1 модуля',
        text: 'Модульный корпус для монтажной рейки для модулей preLink<sup>®</sup> / fixLink<sup>®</sup>, подходит для распределительных шкафов без крышки для автоматических выключателей.',
        datasheets: [
          {
            name: 'Компактный модульный корпус для монтажной рейки для 1 модуля',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Hutschienen-Modulgeh%C3%A4use+und+-Adapterset/ZN-CU161008_B_CKVHECOMOD_EasyLan_Datasheet_Hutschienenmodulgehaeuse_fuer_Sicherungsautomaten.pdf',
          },
        ],
      },
      KeystoneAdapterFKupplung: {
        name: 'Адаптер Keystone-F и пустая заглушка для модуля Keystone',
        text: 'Адаптер F и пустая заглушка для модуля служат заменой для коаксиальных кабелей в патч-панелях preLink<sup>®</sup> / fixLink<sup>®</sup> и программами розеток. Пустая заглушка для preLink<sup>®</sup>/fixLink<sup>®</sup> может использоваться как в распределительном поле, так и в розетках для закрытия неиспользуемых портов.\n\nПустой модуль для SC-S или LC-D как замена модуля\nПустой модуль для SC-S- или LC-D-адаптеров в распределительном поле или розетке.',
      },
      csm_Hutschienenmodul_01_32c872ee2e: {
        name: 'Модульный корпус для монтажной рейки для 1 модуля',
        text: 'Модульный корпус для монтажной рейки для модулей preLink<sup>®</sup> / fixLink<sup>®</sup>, подходит для распределительных шкафов с крышкой для автоматических выключателей.',
        datasheets: [
          {
            name: 'Модульный корпус для монтажной рейки для 1 модуля',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Hutschienen-Modulgeh%C3%A4use+und+-Adapterset/ZN-CU200572_B_CKVHMOD_EasyLan_Datasheet_Carrier_Rail_Modular_Housing_for_one_Modul_.pdf',
          },
        ],
      },
      panel: 'Панель',
      csm_1HE_fixLink_Panel_5f97ddb36b: {
        name: 'Панель 19" 1HE для 24 модулей Keystone с прямым выходом',
        text: 'Распределительное поле 19" 1HE может быть оснащено до 24 модулями preLink<sup>®</sup> / fixLink<sup>®</sup> RJ45 Keystone. Оно выполнено в два уровня, таким образом, модули выровнены с лицевой панелью. Распределительное поле можно заказать из нержавеющей стали или порошкового покрытия железного листа.\n\nМонтажные материалы и модули Keystone не входят в комплект поставки.',
      },
      csm_48x_fixLink_Panel_19a5ba2e55: {
        name: 'Панель 19" 1HE для 48 модулей Keystone с прямым выходом',
        text: 'Распределительное поле 19" 1HE может быть оснащено до 48 модулями fixLink<sup>®</sup> Pro / fixLink<sup>®</sup> Pro+ RJ45 Keystone. Оно выполнено в два уровня, таким образом, модули выровнены с лицевой панелью. Распределительное поле выполнено из порошкового покрытия железного листа.\nМонтажные материалы и модули Keystone не входят в комплект поставки.',
      },
      csm_05HE_panel_fixlink_c73fbc8cf9: {
        name: 'Панель 19" 0,5HE для 24 модулей Keystone с прямым выходом',
        text: 'Распределительное поле preLink<sup>®</sup> / fixLink<sup>®</sup> 19" 0,5HE может быть оснащено до 24 модулями fixLink<sup>®</sup> RJ45 Keystone. Модули выровнены с лицевой панелью.\n\nМонтажные материалы и модули Keystone не входят в комплект поставки.',
      },
      csm_Beschriftungspanel_70ebc940db: {
        name: 'Панель 19" 1HE для 24 модулей Keystone с окном для надписей',
        text: 'Распределительное поле 19" 1HE может быть оснащено до 24 модулями preLink<sup>®</sup> / fixLink<sup>®</sup> RJ45 Keystone. Оно выполнено в два уровня, таким образом, модули выровнены с лицевой панелью. Распределительное поле можно заказать из нержавеющей стали или порошкового покрытия железного листа. Дополнительно имеется возможность маркировать отдельные порты с помощью прилагаемого листа для надписей 12x33.',
      },
      csm_Winkelpanel_30__22e31b820a: {
        name: 'Угловая панель 30° 19" 1HE для 24 модулей Keystone',
        text: 'В угловой панели preLink<sup>®</sup> / fixLink<sup>®</sup> пользователь имеет возможность установить 24 модуля Keystone под углом 30°, благодаря чему подключенные патч-корды автоматически направляются к стороне шкафа и их нужно только зафиксировать сбоку от патчевой зоны. Это позволяет отказаться от дополнительных панелей для управления кабелями. В эксплуатации угловые панели с плоской передней стороной и наклонными патч-кордами занимают меньше места спереди по сравнению с обычными патч-панелями с вертикально установленными портами.\n\nМонтажные материалы и модули Keystone не входят в комплект поставки.',
      },
      baugruppentraeger: 'Держатели компонентов',
      csm_BGT_3HE1_8bf0b66dbe: {
        name: 'Держатель компонентов 19" 3HE для использования модулей вставки',
        text: 'Модульный держатель 19" 3HE для использования модулей вставки 7TE для медных и оптических кабелей. Модули фиксируются на модульном держателе с помощью двух винтов с лицевой стороны. Модули вставки можно полностью извлечь из модульного держателя. В модульном держателе можно закрепить максимум 12 модулей вставки 7TE.',
      },
      csm_fixLink_preLink_Einschubmodul_02_b91415f81e: {
        name: 'Модуль вставки Keystone для модульного держателя',
        text: 'Модуль вставки Keystone для установки в модульные держатели. Модуль вставки Keystone можно оснастить до 6 модулями preLink<sup>®</sup> или fixLink<sup>®</sup> Keystone. Модуль вставки выполнен в два уровня, таким образом, модули выровнены с лицевой панелью. Кабельное крепление осуществляется непосредственно на корпусе модуля вставки. Можно закрепить 6 отдельных кабелей или 1 магистральный кабель.\n\nМонтажные материалы и модули Keystone не входят в комплект поставки.',
      },
      csm_Modulträger_1HE_488e9c42e4: {
        name: 'Модульный держатель (BGT) 19" 1HE для использования модулей вставки',
        text: 'Модульный держатель (BGT) для использования модулей вставки 7TE для медных и оптических кабелей. Модули фиксируются на модульном держателе с помощью двух винтов с лицевой стороны. Модули вставки можно полностью извлечь из модульного держателя. В модульном держателе можно закрепить максимум 3 модуля вставки 7TE (18 портов).\n\nМонтажные материалы и модули Keystone не входят в комплект поставки.',
      },
      csm_Sidemodulträger_3HE_87268249f6: {
        name: 'Боковой модульный держатель 3HE/14TE для использования модулей вставки',
        text: 'Боковой модульный держатель (S-BGT) для использования модулей вставки 7TE для медных и оптических кабелей. Модули вставки фиксируются на модульном держателе с помощью двух винтов с лицевой стороны. Модули вставки можно полностью извлечь из модульного держателя. В модульном держателе можно закрепить максимум 2 модуля вставки 7TE (12 портов). Крепление бокового модульного держателя (S-BGT) осуществляется на боковой стенке шкафа. Это позволяет легко и быстро установить модуль. Боковая установка модуля позволяет реализовать компактное и особенно экологичное кабельное соединение, не нарушая поток воздуха.\n\nМонтажные материалы и модули Keystone не входят в комплект поставки.',
      },
      consolidation_point_panel: 'Панель точки консолидации, DIN-рейки и т. д.',
      csm_CPGehäuse_10___39edc363aa: {
        name: 'Подпольная панель точки консолидации 19" или 10" 1HE',
        text: 'Подпольная панель точки консолидации с заменяемыми лицевыми панелями для установки различных соединений для медных и оптических кабелей. Опционально подпольная панель точки консолидации может быть оснащена замком для защиты от несанкционированного доступа.\n\nМонтажные материалы и модули Keystone не входят в комплект поставки.',
        datasheets: [
          {
            name: 'Панель точки консолидации 10"',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Unterflur-Consolidation+Point+Panel+19%22+bzw.+10%22+1HE/ZN-BL151025_B_CPPF01KS1E_Datasheet_EasyLan_CP_Box_10_Zoll_1U.pdf',
          },
          {
            name: 'Панель точки консолидации 19"',
            href: 'https://s3.eu-central-1.amazonaws.com/think-internet-de.bfs-zvk-easylan/PUBLIC_STORAGE/Unterflur-Consolidation+Point+Panel+19%22+bzw.+10%22+1HE/ZN-BL151024_B_CPPF09KS1E_Datasheet_EasyLan_CP_Box_19_Zoll_1U.pdf',
          },
        ],
      },
      csm_Unterbaupanel_4x_KS_RAL7035_b8b62c45c1: {
        name: 'Настенная панель точки консолидации для 4-12 модулей Keystone',
        text: 'Настенная панель точки консолидации для модулей preLink<sup>®</sup> / fixLink<sup>®</sup> RJ45 Keystone, используется в качестве панели консолидации, для прямого монтажа или с помощью монтажного набора на монтажной рейке в электрических распределительных устройствах. Настенная панель точки консолидации выполнена в два уровня. Таким образом, модули выровнены с лицевой панелью.\n\nМонтажные материалы и модули Keystone не входят в комплект поставки.',
      },
      trunkkabel: 'Магистральные кабели',
      csm_CTBC_Trunkkabel_fixLink_8023e4b1c3: {
        name: 'Система разделения SL CTBC Copper-Trunk-Bundled-Cable, класс EA ISO/IEC',
        text: 'Система разделения CTBC подходит для гибкого использования в структурированном кабельном разводке зданий и центров обработки данных. Кабели, собранные в оплетку, заводски оснащены и проверены модулями fixLink<sup>®</sup> Keystone. Связка может быть выполнена как из установочных кабелей, так и из гибких кабелей. Максимальная длина связанного кабеля составляет до 20 м.',
      },
      csm_CTCC_Trunkkabel_fixLink_efb2b05f62: {
        name: 'Система разделения SL CTCC Copper-Trunk-Compact-Cable, класс EA ISO/IEC',
        text: 'Система разделения CTCC благодаря минимальному диаметру кабеля и, соответственно, низкой пожарной нагрузке подходит для гибкого использования в структурированном кабельном разводке зданий и центров обработки данных. Максимальная длина многожильного кабеля составляет от 60 до 90 м в зависимости от типа. Система разделения как 10-гигабитное решение для разводки в центрах обработки данных соответствует по крайней мере требованиям класса EA.',
      },
      hds_innengabel: 'Внутренний кабель H.D.S.',
      csm_HDS_Innenkabel01_4cd8e032b6: {
        name: 'Внутренний кабель H.D.S. Cat. 7, 6x (4 x 2 x AWG 23) S-FTP B2ca, S-FTP Dca',
        text: 'Внутренний кабель H.D.S. Cat. 7 S/FTP для простого соединения шкафов в центрах обработки данных и многожильных соединений от распределительных комнат до подраспределителей. Кабель состоит из 24 парно экранированных элементов кабеля, по 4 пары собраны в один элемент. Каждый элемент маркирован номерной лентой для облегчения идентификации. Гибкий центральный элемент защиты от натяжения особенно хорошо защищает кабель при протягивании. Оболочка выполнена из гибкого материала LSOH.',
      },
      csm_HDS_Innenkabel01_4cd8e032b7: {
        name: 'Внутренний кабель H.D.S. Cat. 7 6x (4 x 2 x AWG 26) S-FTP Dca',
        text: 'Внутренний кабель H.D.S. Cat. 7 S/FTP для простого соединения шкафов в центрах обработки данных и многожильных соединений от распределительных комнат до подраспределителей. Кабель состоит из 24 парно экранированных элементов кабеля, по 4 пары собраны в один элемент. Каждый элемент маркирован номерной лентой для облегчения идентификации. Гибкий центральный элемент защиты от натяжения особенно хорошо защищает кабель при протягивании. Оболочка выполнена из гибкого материала LSOH.',
      },
      generic: {
        download: 'Скачать',
      },
    },
  },

  imprint: {
    headline: 'Выходные данные',
  },

  dataProtection: {
    headline: 'Защита данных',
  },

  footer: {
    dataProtection: 'Защита данных',
    imprint: 'Выходные данные',
    contact: 'Контакт',
  },

  UI: {
    autocomplete: {
      searchError: 'Не удалось выполнить поиск.',
      searchEmpty: 'Нет результатов',
    },
    dropdown: {
      emptySelection: '--- пожалуйста, выберите ---',
    },
  },
}

export const langKey = 'RU'

const Default = {
  translation,
  langKey,
}

export default Default
